import React from 'react';
import Icon from './AppIcon';

const AdsIndicator = ({ className = '', size = 'sm' }) => {
  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-2.5 py-1.5',
    lg: 'text-base px-3 py-2'
  };

  const iconSizes = {
    xs: 10,
    sm: 12,
    md: 14,
    lg: 16
  };

  return (
    <div 
      className={`inline-flex items-center space-x-1 bg-yellow-100 text-yellow-800 border border-yellow-200 rounded-md font-medium ${sizeClasses[size]} ${className}`}
      title="These games may contain ads"
    >
      <Icon name="AlertTriangle" size={iconSizes[size]} className="flex-shrink-0" />
      <span>May contain ads</span>
    </div>
  );
};

export default AdsIndicator;
